export const DICTS = {
  // 1. Informacje ogólne
  rodzaj_zgloszenia: [
    {
      pl: "Sprzedaż",
      en: "Sale"
    },
    {
      pl: "Leasing",
      en: "Lease"
    },
    {
      pl: "Dzierżawa",
      en: "Leasehold"
    },
    {
      pl: "Informacja",
      en: "Info"
    }
  ],
  rodzaj_nieruchomosci: [
    {
      pl: "Nieruchomość gruntowa",
      en: "Greenfield"
    },
    {
      pl: "Nieruchomość zabudowana",
      en: "Built-up property"
    }
  ],
  rodzaj_umowy_posr: [
    {
      pl: "Brak umowy",
      en: "No contract"
    },
    {
      pl: "Umowa bez wyłączności",
      en: "Non exclusive agreement"
    },
    {
      pl: "Umowa na wyłączność",
      en: "Exclusive agreement"
    }
  ],
  linia_biznesowa_cbre: [
    {
      pl: "Industrial",
      en: "Industrial"
    },
    {
      pl: "Portfolio Management",
      en: "Portfolio Management"
    },
    {
      pl: "Land",
      en: "Land"
    },
    {
      pl: "Investment Properties",
      en: "Investment Properties"
    },
    {
      pl: "Hotels",
      en: "Hotels"
    },
    {
      pl: "Office",
      en: "Office"
    },
    {
      pl: "Industrial",
      en: "Industrial"
    },
    {
      pl: "Retail",
      en: "Retail"
    }
  ],

  // 3. Lokalizacja
  sse: [
    {
      pl: "Nie",
      en: "No"
    },
    {
      pl: "Kamiennogórska SSEMP",
      en: "Kamiennogórska SSEMP"
    },
    {
      pl: "Katowicka SSE",
      en: "Katowicka SSE"
    },
    {
      pl: "Kostrzyńsko-Słubicka SSE",
      en: "Kostrzyńsko-Słubicka SSE"
    },
    {
      pl: "Krakowski Park Technologiczny",
      en: "Krakowski Park Technologiczny"
    },
    {
      pl: "Legnicka SSE",
      en: "Legnicka SSE"
    },
    {
      pl: "Łódzka SSE",
      en: "Łódzka SSE"
    },
    {
      pl: "SSE Euro-Park Mielec",
      en: "SSE Euro-Park Mielec"
    },
    {
      pl: "Pomorska SSE",
      en: "Pomorska SSE"
    },
    {
      pl: "Słupska SSE",
      en: "Słupska SSE"
    },
    {
      pl: "SSE Starachowice",
      en: "SSE Starachowice"
    },
    {
      pl: "Suwalska SSE",
      en: "Suwalska SSE"
    },
    {
      pl:  "TSSE Euro-Park Wisłosan",
      en:  "TSSE Euro-Park Wisłosan"
    },
    {
      pl:  "Wałbrzyska SSE",
      en:  "Wałbrzyska SSE"
    },
    {
      pl:  "Warmińsko-Mazurska SSE",
      en:  "Warmińsko-Mazurska SSE"
    }
  ],

  // 4. Opis terenu
  obecne_uzytkowanie: [
    {
      pl: "Rolnicze",
      en: "Agricultural"
    },
    {
      pl: "Przemysłowe",
      en: "Industrial"
    },
    {
      pl: "Tereny Leśne",
      en: "Forest"
    }
  ],

  // 5. Warunki handlowe i własność
  wlasnosc: [
    {
      pl: "Użytkowanie wieczyste",
      en: "Perpetual usufruct"
    },
    {
      pl: "Własność",
      en: "Ownership"
    },
    {
      pl: "Dzierżawa",
      en: "Leasehold"
    },
    {
      pl: "Opcja deweloperska",
      en: "Developer option"
    },
    {
      pl: "Informacje u osoby podanej do kontaktu",
      en: "Information provided by the contant person"
    }
  ],
  wlasciciel_typ: [
    {
      pl: "Osoby fizyczne",
      en: "Private Individuals"
    },
    {
      pl: "Firma",
      en: "Company"
    },
    {
      pl: "Deweloper",
      en: "Deweloper"
    },
    {
      pl: "Skarb Państwa",
      en: "State treasury"
    },
    {
      pl: "Krajowy Ośrodek Wspierania Rolnictwa",
      en: "National Agricultural Support Center"
    },
    {
      pl: "Władze lokalne",
      en: "Local authorities"
    },
    {
      pl: "Inny podmiot publiczny",
      en: "Other public entity"
    }
  ],
  procedura_nabycia: [
    {
      pl: "Przetarg publiczny",
      en: "Public Tender"
    },
    {
      pl: "Otwarte negocjacje",
      en: "Direct negotiations with site owners"
    },
    {
      pl: "Opcja Deweloperska",
      en: "Developer option"
    },
    {
      pl: "Nie określono",
      en: "Not specified"
    }
  ],

  // 6. Uwarunkowania przestrzenne
  stan_plan: [
    {
      pl: "Miejscowy Plan Zagospodarowania Przestrzennego",
      en: "Local Master Plan"
    },
    {
      pl: "Studium Uwarunkowań i Kierunków Zagospodarowania Przestrzennego",
      en: "Study on the Conditions and Directions of Spatial Development"
    }
  ],
  typ_strefa: [
    {
      pl: "Przemysłowa",
      en: "Industrial"
    },
    {
      pl: "Usługowa",
      en: "Service"
    },
    {
      pl: "Produkcyjna",
      en: "Production"
    },
    {
      pl: "Aktywności Gospodarczej",
      en: "Economic Activity"
    },
    {
      pl: "Mieszkaniowa niska",
      en: "Low Residential"
    },
    {
      pl: "Mieszkaniowa wysoka",
      en: "High Residential"
    },
    {
      pl: "Tereny zielone",
      en: "Green areas"
    },
    {
      pl: "Infrastruktura techniczna",
      en: "Technical infrastructure"
    }
  ],
  stanowisko_do: [
    {
      pl: "Działania potencjalnie niebezpieczne dla środowiska są zabronione.",
      en:
        "Activities potentially hazardous for the environment prohibited at a site."
    },
    {
      pl:
        "Działania potencjalnie niebezpieczne dla środowiska mogą być dozwolone.",
      en:
        "Activities potentially hazardous for the environment can be allowed at a site."
    },
    {
      pl: "Działania potencjalnie niebezpieczne dla środowiska są dozwolone.",
      en:
        "Activities potentially hazardous for the environment allowed at a site."
    },
    {
      pl: "Działania zawsze niebezpieczne dla środowiska są dozwolone.",
      en: "Activities always hazardous for the environment allowed at a site."
    }
  ],
  kontakt_cbre: [],
  klasa_obiektu: [
    {
      pl: "A",
      en: "A"
    },
    {
      pl: "B",
      en: "B"
    },
    {
      pl: "C",
      en: "C"
    }
  ],
  ogrzewanie: [
    {
      pl: "nagrzewnice",
      en: "heater"
    },
    {
      pl: "gazowe",
      en: "gas"
    },
    {
      pl: "piec",
      en: "furnace"
    },
    {
      pl: "brak",
      en: "no heating system"
    }
  ],

  // 7. Informacje o zabudowie
  dodatkowe_instalacje: [
    {
      pl: "suwnica",
      en: "suwnica"
    },
    {
      pl: "sprężone powietrze",
      en: "compressed air"
    },
    {
      pl: "waga",
      en: "scale"
    },
    {
      pl: "klimatyzacja",
      en: "air conditioning"
    },
    {
      pl: "monitoring",
      en: "video surveillance"
    }
  ],

  // 8. Dostęp do nieruchomości
  dr_do_dzialki: [
    {
      pl: "Asfaltowa",
      en: "Asphalt"
    },
    {
      pl: "Utwardzona",
      en: "Paved"
    },
    {
      pl: "Nieutwardzona",
      en: "Unpaved"
    }
  ],
  // Szacowany czas zakupu (miesiące)
  szacowany_czas_zakupu: [
    {
      pl: "styczeń",
      en: "January"
    },
    {
      pl: "luty",
      en: "February"
    },
    {
      pl: "marzec",
      en: "March"
    },
    {
      pl: "kwiecień",
      en: "April"
    },
    {
      pl: "maj",
      en: "May"
    },
    {
      pl: "czerwiec",
      en: "June"
    },
    {
      pl: "lipiec",
      en: "July"
    },
    {
      pl: "sierpień",
      en: "August"
    },
    {
      pl: "wrzesień",
      en: "September"
    },
    {
      pl: "październik",
      en: "October"
    },
    {
      pl: "listopad",
      en: "November"
    },
    {
      pl: "grudzień",
      en: "December"
    }
  ],

  // inne
  info_gleba: [
    {
      pl: "wody gruntowe",
      en: "ground water"
    },
    {
      pl: "zagrożenie powodzią",
      en: "flood risk"
    },
    {
      pl: "inny",
      en: "other"
    }
  ],
  cel: [
    {
      pl: "sklep o pow",
      en: "shop"
    },
    {
      pl: "fabryka",
      en: "factory"
    },
    {
      pl: "magazyn",
      en: "warehouse"
    },
    {
      pl: "stacja benzynowa",
      en: "gas station"
    },
    {
      pl: "mieszkaniówka",
      en: "residential sector"
    },
    {
      pl: "hotele",
      en: "hotels"
    },
    {
      pl: "inny",
      en: "other"
    }
  ],
  work_advancement: [
    {
      pl: "procedowany",
      en: "proceeded"
    },
    {
      pl: "mpzp/wz",
      en: "mpzp/wz"
    },
    {
      pl: "decyzja środowiskowa",
      en: "environmental decision"
    },
    {
      pl: "pozwolenie na budowę",
      en: "building permit"
    }
  ],
  istniejaca_zabud: [
    {
      pl: "produkcyjna",
      en: "production"
    },
    {
      pl: "magazynowa",
      en: "warehouse"
    },
    {
      pl: "biurowa",
      en: "office"
    },
    {
      pl: "inny",
      en: "other"
    }
  ],
  boolean: [
    {
      pl: "tak",
      en: "yes",
      bool: true
    },
    {
      pl: "nie",
      en: "no",
      bool: false
    }
  ]
};
